import { Form, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSSelect from 'components/CIMSSelect'
import { CIMSSelectProps } from 'components/CIMSSelect/types'
import CIMSTextArea from 'components/CIMSTextArea'

const GiveDispositionFormItems: React.FC<
  Pick<CIMSSelectProps, 'options' | 'loading'>
> = ({ options, loading }) => {
  const help = HelpMessage.Issues.IssueTracker
  return (
    <>
      <Form.Item hidden name="action" initialValue="give">
        <Input />
      </Form.Item>
      <CIMSFormItem
        name="dispositionType"
        help={help.Disposition}
        label="Disposition"
        requiredMessage="Please select a disposition type"
      >
        <CIMSSelect options={options} loading={loading} />
      </CIMSFormItem>
      <CIMSFormItem
        name="dispositionNotes"
        label="Disposition Notes"
        requiredMessage
        help={help.DispositionNotes}
      >
        <CIMSTextArea maxLength={2000} />
      </CIMSFormItem>
    </>
  )
}

export default GiveDispositionFormItems
